import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useLayoutStore = defineStore('layout', () => {
  // Global control for announcement banner visibility
  // Set to true to show the banner and increase page margin-top
  // Set to false to hide the banner and use default margin-top
  const showAnnouncementBanner = ref(false)

  // Computed margin-top value for pages based on banner visibility
  const pageMarginTop = computed(() => {
    return showAnnouncementBanner.value ? '120px' : '55px'
  })

  return {
    showAnnouncementBanner,
    pageMarginTop
  }
})
